import React, { useContext, useEffect, useRef, useState } from 'react';
import ActionProvider from '../cnr/contexts/ActionContext';
import AlphaProvider from '../cnr/contexts/AlphaContext';
import DataProvider from '../cnr/contexts/DataContext';
import FilterProvider from '../cnr/contexts/FilterContext';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import ItemStorageProvider from '../cnr/contexts/ItemStorageContext';
import { PageAreaContext } from '../cnr/contexts/PageAreaContext';
import { PapsContext } from '../cnr/contexts/PapsContext';
import UiItemProvider from '../cnr/contexts/UiItemContext';
import ErrorBoundaryWithNavigate from '../components/errorHandling/ErrorBoundaryWithNavigate';
import { gEnums } from '../enums/globalEnums';
import UiItem from '../pageItem/UiItem';

const NonAuthPage = React.lazy(() => import("../components/alerts/NonAuthPage"));
const PageItemAlt = React.lazy(() => import("./PageItemAlt"));
const UnderMaintenancePage = React.lazy(() => import("../components/alerts/UnderMaintenancePage"));

const _allowNones = true

// const _showMemos = false
// 
const PageItem = (props) => {

  const { uivi, tabIndex, caption, viewItem_app, inSwiper, isMounted } = props;

  const [isPageItemLoaded, setIsPageItemLoaded] = useState(false);

  const papsContext = useContext(PapsContext);
  const { history } = papsContext ?? {};

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {};
  const { desktopMode } = framework_state ?? {};

  const pageAreaContext = useContext(PageAreaContext);
  const { pageArea_state } = pageAreaContext ?? {};
  const { pageItemsShown } = pageArea_state ?? {};

  const viewItem_page = pageItemsShown?.[uivi] || {};
  const { general, _viewPermissionType, display, desktopDisplay } = viewItem_page ?? {};
  const _display = desktopMode && desktopDisplay ? desktopDisplay : display;
  const { displayType } = _display ?? {};
  const { itemUnderMaintenance } = general ?? {};

  // ✅ Run effect unconditionally
  useEffect(() => {
    if (isPageItemLoaded) return;
    if (inSwiper && !isMounted) return;
    setIsPageItemLoaded(true);
  }, [isMounted, inSwiper, isPageItemLoaded]);

  // 🔽 Render logic ONLY below here

  if (itemUnderMaintenance) {
    return <UnderMaintenancePage itemType="item" />;
  }

  switch (_viewPermissionType) {
    case gEnums.viewPermissionTypes.deny:
    case gEnums.viewPermissionTypes.deny_noClientKey:
    case gEnums.viewPermissionTypes.deny_noEventKey:
      return <NonAuthPage history={history} itemType="item" vpt={_viewPermissionType} />;
    default:
      break;
  }

  const altTypes = gEnums.additionalPageItemTypes;
  if (Object.values(altTypes).includes(displayType)) {
    return <PageItemAlt viewItem_page={viewItem_page} displayType={displayType} />;
  }

  if (inSwiper && !isMounted && _allowNones) {
    // console.log(`✅${uivi}`)
    return null;
  }

  if (!isPageItemLoaded && _allowNones) {
    // console.log(`✅🗄️${uivi}`)
    return null;
  }

  return (
    <ErrorBoundaryWithNavigate origin="pageItem">
      <DataProvider uivi={uivi}>
        <ActionProvider>
          <FilterProvider>
            <AlphaProvider>
              <UiItemProvider>
                <ItemStorageProvider>
                  <UiItem
                    tabIndex={tabIndex}
                    caption={caption}
                    viewItem_app={viewItem_app}
                    uivi={uivi}
                  />
                </ItemStorageProvider>
              </UiItemProvider>
            </AlphaProvider>
          </FilterProvider>
        </ActionProvider>
      </DataProvider>
    </ErrorBoundaryWithNavigate>
  );
};

export default PageItem


// const PageItem = (props) => {

//   const _apits = gEnums.additionalPageItemTypes

//   const { uivi, tabIndex, caption, viewItem_app, inSwiper, isMounted } = props

//   // Only call useSwiperSlide if inSwiper
//   const swiperSlide = inSwiper ? useSwiperSlide() : { isActive: true }
//   // const { isActive } = swiperSlide

//   const [isLoaded, setIsLoaded] = useState(false)
//   const renderedRef = useRef(null)

//   // papsContext
//   const papsContext = useContext(PapsContext);
//   const { history } = papsContext ?? {}

//   // frameworkContext
//   const frameworkContext = useContext(FrameworkContext);
//   const { framework_state } = frameworkContext ?? {}
//   const { desktopMode } = framework_state ?? {}

//   // pageAreaContext
//   const pageAreaContext = useContext(PageAreaContext)
//   const { pageArea_state } = pageAreaContext ?? {}
//   const { pageItemsShown } = pageArea_state ?? {}
//   const viewItem_page = pageItemsShown?.[uivi] || {}
//   const { general, _viewPermissionType, display, desktopDisplay } = viewItem_page ?? {}
//   const _display = desktopMode && desktopDisplay ? desktopDisplay : display
//   const { displayType } = _display ?? {}
//   const { itemUnderMaintenance } = general ?? {}

//   if (itemUnderMaintenance) { return <UnderMaintenancePage itemType={'item'} /> }

//   switch (_viewPermissionType) {
//     case gEnums.viewPermissionTypes.deny:
//     case gEnums.viewPermissionTypes.deny_noClientKey:
//     case gEnums.viewPermissionTypes.deny_noEventKey:
//       return <NonAuthPage history={history} itemType={'item'} vpt={_viewPermissionType} />
//     default:
//       // nothing. continue
//       break;
//   }

//   switch (displayType) {
//     case _apits.feeds:
//     case _apits.gallery:
//     case _apits.geoList:
//     case _apits.geoLocation:
//     case _apits.media:
//     case _apits.pdfs:
//     case _apits.photos:
//     case _apits.questionsAndAnswers:
//     case _apits.tickets:
//     case _apits.tickets:
//     case _apits.travelInfo:
//     case _apits.twitter:
//     case _apits.videoLinks:
//       return <PageItemAlt viewItem_page={viewItem_page} displayType={displayType} />
//     default:
//     // nothing
//   }

//   const _piElement = () => <ErrorBoundaryWithNavigate origin="pageItem">
//     <DataProvider uivi={uivi}>
//       <ActionProvider>
//         <FilterProvider>
//           <AlphaProvider>
//             <UiItemProvider>
//               <ItemStorageProvider>
//                 <UiItem
//                   tabIndex={tabIndex}
//                   caption={caption}
//                   viewItem_app={viewItem_app}
//                   uivi={uivi}
//                 />
//               </ItemStorageProvider>
//             </UiItemProvider>
//           </AlphaProvider>
//         </FilterProvider>
//       </ActionProvider>
//     </DataProvider>
//   </ErrorBoundaryWithNavigate>


//   // 1️⃣ Only run loading logic once when mounted
//   useEffect(() => {
//     // already loaded? never do this again
//     if (isLoaded) return;
//     // swiper items only load once mounted
//     if (inSwiper && !isMounted) return;
//     console.log(`🟩🟩${caption || uivi}`);
//     // const elem = _piElement();
//     renderedRef.current = _piElement();
//     setIsLoaded(true);
//   }, [isMounted, isLoaded, inSwiper]);

//   if (inSwiper && !isMounted) {
//     return <div></div>
//   }

//   if (uivi) {
//     return renderedRef.current
//   }

//   return <div>--</div>

// }

// export default PageItem
